<template lang="html">
 	<div class="downloadList-container">
        <div class="breadCrumb-container">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>{{$t('message.alert')}}</el-breadcrumb-item>
				<el-breadcrumb-item>{{$t('message.alertHistory')}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

        <div class="body-container">
            <div class="table-container verifone-panel">
        		<div class="table-main">
                    <template>
                        <el-table :data="tableData" style="width: 100%">
                            <el-table-column prop="sn" label="SN" :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="model" :label="$t('message.model')" width="100"></el-table-column>
                            <el-table-column prop="merchant" :show-overflow-tooltip="true" :label="$t('message.merchant')"></el-table-column>
                            <el-table-column prop="date" :show-overflow-tooltip="true" :label="$t('message.date')"></el-table-column>
                            <el-table-column prop="type" :show-overflow-tooltip="true" :label="$t('message.type')"></el-table-column>
                            <el-table-column prop="level" :show-overflow-tooltip="true" :label="$t('message.level')" width="120">
                            	<template slot-scope="scope">
									<span v-if="scope.row.level == 'm'" class="middle-icon"></span>
									<span v-if="scope.row.level == 'h'" class="high-icon"></span>
									<span v-if="scope.row.level == 'm'" size="small">{{$t('message.middle')}}</span>
                                    <span v-if="scope.row.level == 'h'" size="small">{{$t('message.high')}}</span>
                            	</template>
                            </el-table-column>
                        </el-table>
                    </template>
        		</div>

        		<div class="pagination-main">
        			<el-pagination  background layout="prev, pager, next" :total="totalPage*10" @current-change="queryAlertList"></el-pagination>
        		</div>
        	</div>
        </div>


        <el-dialog title="Tips" :visible.sync="cancelDialogVisible" width="30%" class="quit-dialog">
            <div class="flex-col tip-content">
				<div><img class="tipImg" src="static/img/tip.png"></div>
				<div class="tipTxt">Are you sure you want to cancel tasks?</div>
			</div>
            <!-- <span>Are you sure you want to cancel tasks?</span> -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelDialogVisible = false">Cancel</el-button>
                <el-button type="success" @click="callStopTask(cancelId)">OK</el-button>
            </span>
        </el-dialog>

 	</div>
</template>

<script>
export default {
	data() {
		return {
            cancelDialogVisible: false,
            currentType: null,
            cancelId: '',
            currentPage: 1,
            totalPage: 1,
			tableData: []
		}
	},
    mounted() {
        this.queryAlertList(1);
    },
	methods: {
		handleClick(row) {
            console.log(row);
        },
        handleDetail(row) {
            let id = row.taskId;

            if(row.taskType == 0) {
                this.queryTaskDetail(0, id);
            }else if(row.taskType == 1) {
                this.queryTaskDetail(1, id);
            }else if(row.taskType == 2) {
                this.queryTaskDetail(2, id);
            }
        },
        handleStopTask(row) {
            this.cancelId = row.taskId;
            this.cancelDialogVisible = true;
        },
        queryAlertList(page) {
            let that = this;
            let obj = {
                pageNum: page
            };

            that.currentPage = page;

            this.$axios({
                method: 'post',
                url: '/marketplace/alert/history/page',
                headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
                data: obj
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'3000',
                    });
                    return;
                }else {
                    that.tableData = response.data.alerts;
                    that.totalPage = response.data.totalPage;
                }
            }).catch((err) => {
                console.log(err);
            });
        }
	}

}
</script>

<style lang="css" scoped="scoped">
.table-container {
	margin-top: 60px;
}
.has-gutter {
	border-bottom: 1px solid #00a0e8;
}
.table-main {
	padding: 20px;
}
.pagination-main {
	padding: 10px 0;
}
.createBtn-main {
	display: flex;
	display: -webkit-flex;
	flex-direction: row;
	position: absolute;
	right: 0;
	bottom: 10px;
	align-items: center;
	padding-right: 10px;
}
.load-selector {
	background-color: #53bfb7!important;
	color: #fff!important;
	padding: 10px 15px;
	margin: 0 3px 0 20px;
}
.arrows-right {
	width: 25px;
	height: 25px;
	transform: rotate(180deg);
	position: relative;
	bottom: -7px;
}
.num-container {
	font-size: 15px;
	color: #666;
}
.taskName {
    color: #00A0E8;
    cursor: pointer;
}
.end-btn {
    color: #fff;
    background-color: #E51C23;
    padding: 8px 12px;
}
.is-disabled {
    color: #fff;
    background-color: #8E8E8E!important;
}
.app-icon {
	width: 38px;
	height: 38px;
}
.detail-row {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    padding: 0 0 12px 0;
}
.downloadLabel {
    width: 128px;
}
.downloadDate {
    display: inline-block;
    width: 180px;
}
.title-container {
    padding-left: 20px;
}
.high-icon {
	display: inline-block;
	width: 16px;
	height: 16px;
	border-radius: 50%;
	position: relative;
	top: 3px;
	background-color: #db1e08;
	border: 3px solid #f5c8c2;
}
.middle-icon {
	display: inline-block;
	width: 16px;
	height: 16px;
	border-radius: 50%;
	position: relative;
	top: 3px;
	background-color: #fdb201;
	border: 3px solid #fdecbe;
}
</style>



// WEBPACK FOOTER //
// src/components/page/AlertHistory.vue